





























import { Component, Vue, Prop } from 'nuxt-property-decorator';

import { IconArrowRight } from '@/icons';

@Component({
  components: {
    IconArrowRight,
  },
})
export default class ShowDateListItem extends Vue {
  @Prop({ type: String })
  to!: string

  @Prop(String)
  image!: string

  @Prop({ type: String, required: true })
  title!: string

  @Prop({ type: String, required: true })
  subtitle!: string

  @Prop(String)
  bookingLink!: string

  @Prop(Boolean)
  soldOut!: boolean

  @Prop(Boolean)
  cancelled!: boolean

  get linkIsEnabled () {
    return this.bookingLink && !this.cancelled && !this.soldOut;
  }

  get linkProps () {
    if (!this.linkIsEnabled)
      return {};

    return {
      rel: 'noopener noreferrer',
      target: '_blank',
    };
  }
}
